import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

const DietModal = ({ open, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    dietType: '',
    restrictions: '',
    feedingMode: '',
    dieticianReferral: ''
  });
  const [addToTaskList, setAddToTaskList] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.dietType) return;
    onSubmit(formData, { addToTaskList });
    setFormData({ dietType: '', restrictions: '', feedingMode: '', dieticianReferral: '' });
    setAddToTaskList(false);
    onClose();
  };

  const handleChange = (field) => (e) => {
    setFormData(prev => ({ ...prev, [field]: e.target.value }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Diet Plan</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Diet Type *</Typography>
              <TextField
                fullWidth
                size="small"
                required
                placeholder="e.g., Diabetic Diet, Low Sodium, NPO"
                value={formData.dietType}
                onChange={handleChange('dietType')}
              />
            </Box>

            <Box>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Dietary Restrictions <Typography component="span" color="text.secondary">(Optional)</Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                multiline
                rows={2}
                placeholder="e.g., No sugar, low fat, gluten-free"
                value={formData.restrictions}
                onChange={handleChange('restrictions')}
              />
            </Box>

            <Box>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Feeding Mode <Typography component="span" color="text.secondary">(Optional)</Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="e.g., Oral, NG Tube, Parenteral"
                value={formData.feedingMode}
                onChange={handleChange('feedingMode')}
              />
            </Box>

            <Box>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Dietician Referral <Typography component="span" color="text.secondary">(Optional)</Typography>
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="e.g., Yes - for nutritional assessment"
                value={formData.dieticianReferral}
                onChange={handleChange('dieticianReferral')}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, display: 'flex', justifyContent: 'space-between' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={addToTaskList}
                onChange={(e) => setAddToTaskList(e.target.checked)}
              />
            }
            label="Add to task list"
          />
          <Box>
            <Button onClick={onClose} variant="outlined" sx={{ mr: 1 }}>Cancel</Button>
            <Button type="submit" variant="contained">Add Diet Plan</Button>
          </Box>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default DietModal;
